/**
 * 常用的方法
 */

import moment from 'moment';
const queryString = require('query-string');

export function SliceStr(sourceStr, num) {
	if (!sourceStr) {
		return;
	}
	if (sourceStr.length < num) return sourceStr
	else {
		return sourceStr.slice(0, num) + '...';
		//return <span title={sourceStr}>{sourceStr.slice(0, num) + '...'}</span>
	}
}

export function FilterDate(d, format = 'YYYY-MM-DD') {
	var mm = new moment(d);
	return mm.format(format);
}

export function GetQueryStringParames(url, key) {
	var obj = queryString.parse(url);
	return obj[key];
	// var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
	// var r = url.substr(1).match(reg);  //匹配目标参数
	// if (r != null) return unescape(r[2]);
	// return null; //返回参数值
}


// WEBPACK FOOTER //
// ./src/lib/util/common.js